module.exports = __webpack_public_path__ + "static/media/Deathrow-logo-top.8e47868d.jpg";